import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

console.log('App Entry Point: Environment Variables:', {
  REACT_APP_LOGTO_ENDPOINT: process.env.REACT_APP_LOGTO_ENDPOINT,
  REACT_APP_LOGTO_APP_ID: process.env.REACT_APP_LOGTO_APP_ID,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  NODE_ENV: process.env.NODE_ENV
});



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
